import { AxiosResponse } from "axios";
import { PartCatalogDetailRequest, PartCatalogRequest } from "@/main/models/request";
import { Result } from "@/main/models/common/resultResponse";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import {
	PartCatalogDetailResponse,
	PartCatalogResponse,
	PartCatalogSuggestionResponse,
} from "@/main/models/response/partCatalogResponse";

export abstract class IPartCatalogApi {
	abstract searchgrid(request: PartCatalogRequest): Promise<AxiosResponse<PaginationResponse<PartCatalogResponse>>>;

	abstract detail(request: PartCatalogDetailRequest): Promise<AxiosResponse<Result<PartCatalogDetailResponse>>>;

	abstract getSuggestion(partNumber: string): Promise<AxiosResponse<Result<PartCatalogSuggestionResponse>>>;
}
